export default "__VITE_ASSET__pWGDiLarX$B46SDc2SQYmg__"